(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-care-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-care-drawer')) {
    customElements.define('product-care-drawer', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.querySelector('[data-care-open]')?.addEventListener('click', () => this.dialog?.showModal());
        this.querySelector('[data-care-close]')?.addEventListener('click', () => this.dialog?.close());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
